{
  "title": {
    "profileAndAvatar": "PERFIL Y AVATAR",
    "mapAvatar": "AVATAR DEL MAPA INTERACTIVO",
    "description": "DESCRIPCION",
    "location": "UBICACIÓN",
    "religion": "RELIGION",
    "skills": "SKILLS",
    "officialDocuments": "DOCUMENTOS OFICIALES"
  },
  "changePhoto": "Cambiar foto",
  "guestFallback": "Invitado",
  "namePlaceholder": "Nombre",
  "emailPlaceholder": "Correo",
  "createAvatarTooltip": "Crear mi propio avatar",
  "createCharacterLabel": "Crear mi propio personaje",
  "descriptionPlaceholder": "Escribe una breve descripción...",
  "locationPlaceholder": "Ciudad, País",
  "religionPlaceholder": "Añadir religión",
  "skillsPlaceholder": "Agregar habilidad...",
  "stats": {
    "contributions": "Contribuciones",
    "timeActive": "Tiempo activo"
  },
  "docs": {
    "idFront": "ID Frente",
    "idBack": "ID Reverso",
    "addressProof": "Comprobante Dom.",
    "curp": "CURP",
    "birthCert": "Acta de Nacimiento",
    "noneUploaded": "No hay documentos subidos."
  },
  "toast": {
    "visibilityChangeFailed": "No se pudo cambiar la visibilidad",
    "occupied": "Ocupado",
    "unavailable": "No disponible",
    "savedSuccess": "¡Guardado exitosamente!",
    "error": "Error",
    "errorSavingProfile": "Error al guardar el perfil",
    "uploadingImage": "Subiendo imagen...",
    "imageSaved": "¡Imagen de perfil guardada en la nube!",
    "uploadFailed": "Error al subir: {{message}}"
  },
  "characterGallery": {
    "loading": "Cargando personajes...",
    "emptyTitle": "No hay personajes creados todavía.",
    "emptySubtitle": "Sé el primero en crear uno.",
    "availableTitle": "Personajes disponibles",
    "deselectTooltip": "Clic para quitar y volver a foto de perfil",
    "by": "por {{creator}}"
  },
  "security": {
    "title": "SEGURIDAD",
    "editButton": "Editar accesos",
    "modalTitle": "Editar accesos",
    "modalSubtitle": "Cambia tu usuario y/o tu contraseña. Necesitamos tu contraseña actual para confirmar que eres tú.",
    "nickLabel": "Usuario",
    "nickPlaceholder": "Tu nombre de usuario",
    "newPasswordLabel": "Contraseña nueva (opcional)",
    "newPasswordPlaceholder": "Mínimo 8 caracteres...",
    "confirmPasswordLabel": "Confirmar contraseña nueva",
    "confirmPasswordPlaceholder": "Vuelve a escribir la contraseña nueva...",
    "currentPasswordLabel": "Contraseña actual",
    "currentPasswordPlaceholder": "Tu contraseña actual",
    "currentPasswordHint": "La necesitamos para confirmar que el cambio lo estás haciendo tú.",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando...",
    "savedSuccess": "Tus accesos se actualizaron correctamente.",
    "errors": {
      "noChanges": "No hiciste ningún cambio de usuario o contraseña.",
      "passwordTooShort": "La contraseña nueva debe tener al menos 8 caracteres.",
      "passwordMismatch": "Las contraseñas no coinciden.",
      "currentPasswordRequired": "Escribe tu contraseña actual para confirmar el cambio.",
      "generic": "No se pudo actualizar tus accesos. Intenta de nuevo."
    }
  }
}
